import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faArrowUp, faArrowDown, faSync, faEye, faChevronDown, faChevronUp, faUpload } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import './ProductosData.css'
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import NewProduct from '../NewProduct/NewProduct';
import moneda from '../../moneda';
import { Link as Anchor } from "react-router-dom";
import ImportarProductos from './ImportarProductos/ImportarProductos';
export default function ProductosData() {
    const [productos, setProductos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [producto, setProducto] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroCategoria2, setFiltroCategoria2] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [nuevaImagen, setNuevaImagen] = useState(null);
    const [nuevaImagen2, setNuevaImagen2] = useState(null);
    const [nuevaImagen3, setNuevaImagen3] = useState(null);
    const [nuevaImagen4, setNuevaImagen4] = useState(null);
    const [selectedSection, setSelectedSection] = useState('texto');
    const [nuevoEsAccesorio, setNuevoEsAccesorio] = useState('');
    const [nuevoMasVendido, setNuevoMasVendido] = useState('');
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [stockItem1, setStockItem1] = useState(0);
    const [stockItem2, setStockItem2] = useState(0);
    const [stockItem3, setStockItem3] = useState(0);
    const [stockItem4, setStockItem4] = useState(0);
    const [stockItem5, setStockItem5] = useState(0);
    const [modulo, setNuevoModulo] = useState('');
    const [nivel, setNuevoNivel] = useState('');
    const [viewAllSizes, setViewAllSizes] = useState(null);
    const [errores, setErrores] = useState({});
    
    // Estados para importar productos
    const [modalImportacionVisible, setModalImportacionVisible] = useState(false);

    // Estado para la página actual
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Cantidad de productos por página

    // Calcular índices para los productos de la página actual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // Cambiar página
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };
    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };


    useEffect(() => {
        cargarProductos();

    }, [filtroCategoria]);

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoTitulo(producto.titulo || '');
        setNuevaDescripcion(producto.descripcion || '');
        setNuevoPrecio(producto.precio || '');
        setNuevoEsAccesorio(producto.esAccesorio || '');
        setNuevoMasVendido(producto.masVendido || '');
        setNuevaCategoria(producto.idCategoria || '');
        setItem1(producto.item1 || '');
        setItem2(producto.item2 || '');
        setItem3(producto.item3 || '');
        setItem4(producto.item4 || '');
        setItem5(producto.item5 || '');
        setNuevoPrecioAnterior(producto.precioAnterior || '');
        setStockItem1(producto.stockItem1 || 0);
        setStockItem2(producto.stockItem2 || 0);
        setStockItem3(producto.stockItem3 || 0);
        setStockItem4(producto.stockItem4 || 0);
        setStockItem5(producto.stockItem5 || 0);
        setNuevoModulo(producto.modulo || '');
        setNuevoNivel(producto.nivel || '');
    }, [producto]);

    const cargarProductos = () => {
        fetch(`${baseURL}/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                if (filtroCategoria !== '') {
                    setProductos(data.productos.filter(producto => (producto.idCategoria == filtroCategoria)) || []);
                } else {
                    setProductos(data.productos || []);
                }
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const eliminarProducto = (idProducto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/productDelete.php?idProducto=${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarProductos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setNuevoTitulo(item.titulo);
        setNuevaDescripcion(item.descripcion);
        setNuevoPrecio(item.precio);
        setNuevaCategoria(item.idCategoria);
        setModalVisible(true);
        setNuevoModulo(item.modulo || '');
        setNuevoNivel(item.nivel || '');
        setNuevoEsAccesorio(item.esAccesorio || '');
        setNuevoMasVendido(item.masVendido || '');
        setViewAllSizes(item.esAccesorio == 'si' ? false : true);
        setErrores({}); // Limpiar errores al abrir el modal
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const productosFiltrados = productos.filter(item => {
        const idMatch = item.idProducto.toString().includes(filtroId);
        const tituloMatch = !filtroTitulo || item.titulo.includes(filtroTitulo);
        const categoriaMatch = item.idCategoria.toString().includes(filtroCategoria);
        const categoriasMatch = !filtroCategoria2 || item.categoria.includes(filtroCategoria2);
        return idMatch && tituloMatch && categoriaMatch && categoriasMatch;
    });

    const currentItems = productosFiltrados.slice(indexOfFirstItem, indexOfLastItem);

    const descargarExcel = () => {
        const data = productosFiltrados.map(item => ({
            idProducto: item.idProducto,
            titulo: item.titulo,
            descripcion: item.descripcion,
            precio: item.precio,
            precioAnterior: item.precioAnterior || '',
            categoria: item.categoria || '',
            masVendido: item.masVendido || 'No',
            'Inventario Ch': item.stockItem1 || 0,
            'Inventario M': item.stockItem2 || 0,
            'Inventario G': item.stockItem3 || 0,
            'Inventario Xg': item.stockItem4 || 0,
            'Inventario Xxg': item.stockItem5 || 0,
            nivel: item.nivel || '',
            modulo: item.modulo || '',
            esAccesorio: item.esAccesorio || 'No',
            orden: item.orden || ''
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'productos.xlsx');
    };

    async function getBase64ImageFromUrl(url) {
        return await fetch(url)
            .then(response => response.blob())
            .then(blob =>
                new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                })
            );
    }

    const descargarPDF = () => {
        const pdf = new jsPDF({ orientation: 'landscape' });
        const titulo = "Lista de Productos";
        const fecha = `Fecha de reporte: ${new Date().toISOString().split("T")[0]}`;

        // Agregar título y fecha
        pdf.text(titulo, 10, 10);

        const pageWidth = pdf.internal.pageSize.getWidth();
        const fechaWidth = pdf.getTextWidth(fecha);
        const fechaX = pageWidth - fechaWidth - 10;
        pdf.text(fecha, fechaX, 10);

        // Definir las columnas para la tabla, incluyendo "Categoría" y "Total Prendas"
        const columns = [
            { title: "Id", dataKey: "idProducto" },
            { title: "Imagen", dataKey: "imagen" },
            { title: "Titulo", dataKey: "titulo" },
            { title: "Descripción", dataKey: "descripcion" },
            { title: "Precio", dataKey: "precio" },
            { title: "Categoría", dataKey: "categoria" },
            { title: "Fecha", dataKey: "createdAt" },
            { title: "Ch", dataKey: "stockItem1" },
            { title: "M", dataKey: "stockItem2" },
            { title: "G", dataKey: "stockItem3" },
            { title: "Xg", dataKey: "stockItem4" },
            { title: "Xxg", dataKey: "stockItem5" },
            { title: "Total", dataKey: "totalPrendas" },
        ];

        // Procesar datos: sumatoria por fila
        const data = productosFiltrados.map((item) => {
            const total =
                Number(item.stockItem1 || 0) +
                Number(item.stockItem2 || 0) +
                Number(item.stockItem3 || 0) +
                Number(item.stockItem4 || 0) +
                Number(item.stockItem5 || 0);

            return {
                idProducto: item.idProducto,
                imagen: '',
                titulo: item.titulo.slice(0, 20),
                descripcion: item.descripcion.slice(0, 20),
                precio: `$${item.precio}`,
                categoria: item.categoria || "-", // Se asegura tener siempre una categoría válida
                createdAt: item.createdAt.split(" ")[0],
                stockItem1: item.stockItem1,
                stockItem2: item.stockItem2,
                stockItem3: item.stockItem3,
                stockItem4: item.stockItem4,
                stockItem5: item.stockItem5,
                totalPrendas: total,
            };
        });

        // Agrupación de productos por categoría y cálculo de sumatorias
        const categoriaTotales = {};
        data.forEach((item) => {
            if (!categoriaTotales[item.categoria]) {
                categoriaTotales[item.categoria] = 0;
            }
            categoriaTotales[item.categoria] += item.totalPrendas; // Ir sumando las tallas por categoría
        });

        // Crear texto para mostrar las sumatorias por categoría
        let lineaCategorias = 20; // Coordenada vertical inicial para las categorías (justo debajo del título y la fecha)
        pdf.setFontSize(11); // Ajustar el tamaño de fuente para que sea más pequeño
        Object.entries(categoriaTotales).forEach(([categoria, total]) => {
            pdf.text(`${categoria}: ${total} piezas`, 10, lineaCategorias);
            lineaCategorias += 7; // Espaciado entre líneas
        });

        // Calcular la sumatoria global de todas las prendas
        const totalGlobal = data.reduce((acc, row) => acc + row.totalPrendas, 0);

        // Mostrar el total global justo debajo de las categorías
        pdf.text(`Total global: ${totalGlobal} piezas`, 10, lineaCategorias);

        // Iniciar tabla un poco más abajo para evitar superposición
        const startY = lineaCategorias + 10; // Ajusta la posición inicial según la cantidad de categorías
        pdf.autoTable({
            startY,
            head: [columns.map((col) => col.title)],
            body: data.map((item) => Object.values(item)),
            didDrawCell: async (data) => {
                if (data.column.index === 1 && data.cell.section === 'body') {
                    const producto = productosFiltrados[data.row.index];
                    if (producto?.imagen1) {
                        try {
                            // Tamaño de la celda
                            const cellWidth = data.cell.width;
                            const cellHeight = data.cell.height;

                            // Tamaño de la imagen (ajustar para que quepa en la celda)
                            const imgWidth = cellWidth - 2; // Margen pequeño
                            const imgHeight = cellHeight - 2;

                            // Posición (centrada en la celda)
                            const x = data.cell.x + (cellWidth - imgWidth) / 2;
                            const y = data.cell.y + (cellHeight - imgHeight) / 2;

                            // Agregar la imagen
                            pdf.addImage(
                                await getBase64ImageFromUrl(producto?.imagen1),
                                'JPEG', // o 'PNG' según corresponda
                                x,
                                y,
                                imgWidth,
                                imgHeight
                            );
                        } catch (error) {
                            console.error('Error al cargar la imagen:', error);
                            pdf.text('Imagen no disponible', data.cell.x + 2, data.cell.y + 5);
                        }
                    }
                }
            },
        });

        // Guardar el PDF
        pdf.save("productos.pdf");
    };


    const recargarProductos = () => {
        cargarProductos();
    };
    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };


    const handleUpdateText = (idProducto) => {
        // Validar campos obligatorios
        const nuevosErrores = {};
        
        if (!nuevoTitulo || nuevoTitulo.trim() === '') {
            nuevosErrores.titulo = 'El título es obligatorio';
        }
        
        if (!nuevoPrecio || nuevoPrecio <= 0) {
            nuevosErrores.precio = 'El precio es obligatorio y debe ser mayor a 0';
        }
        
        if (!nuevaCategoria || nuevaCategoria === '') {
            nuevosErrores.categoria = 'La categoría es obligatoria';
        }
        
        if (!nuevoMasVendido || nuevoMasVendido === '') {
            nuevosErrores.masVendido = 'El campo "Más vendido" es obligatorio';
        }
        
        if (!nuevoEsAccesorio || nuevoEsAccesorio === '') {
            nuevosErrores.esAccesorio = 'El campo "Es accesorio" es obligatorio';
        }

        // Si hay errores, mostrarlos y no continuar
        if (Object.keys(nuevosErrores).length > 0) {
            setErrores(nuevosErrores);
            toast.error('Por favor, complete todos los campos obligatorios');
            return;
        }

        // Limpiar errores si todo está bien
        setErrores({});

        const payload = {
            nuevoTitulo: nuevoTitulo !== '' ? nuevoTitulo : producto.titulo,
            nuevaDescripcion: nuevaDescripcion !== undefined ? nuevaDescripcion : producto.descripcion,
            nuevoPrecio: nuevoPrecio !== '' ? nuevoPrecio : producto.precio,
            nuevaCategoria: nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria,
            esAccesorio: nuevoEsAccesorio !== '' ? nuevoEsAccesorio : producto.esAccesorio,
            masVendido: nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido,
            item1: item1 !== undefined ? item1 : producto.item1,
            item2: item2 !== undefined ? item2 : producto.item2,
            item3: item3 !== undefined ? item3 : producto.item3,
            item4: item4 !== undefined ? item4 : producto.item4,
            item5: item5 !== undefined ? item5 : producto.item5,
            precioAnterior: nuevoPrecioAnterior !== 0 ? nuevoPrecioAnterior : producto.precioAnterior,
            stockItem1: stockItem1 !== undefined ? stockItem1 : producto.stockItem1,
            stockItem2: stockItem2 !== undefined ? stockItem2 : producto.stockItem2,
            stockItem3: stockItem3 !== undefined ? stockItem3 : producto.stockItem3,
            stockItem4: stockItem4 !== undefined ? stockItem4 : producto.stockItem4,
            stockItem5: stockItem5 !== undefined ? stockItem5 : producto.stockItem5,
            modulo: modulo !== '' ? modulo : producto.modulo,
            nivel: nivel !== '' ? nivel : producto.nivel,
        };

        fetch(`${baseURL}/productoTextPut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {

                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {

                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarProductos();
                    cerrarModal()
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };

    const handleFileChange = (event, setFile, setPreview) => {
        const file = event.target.files[0];

        if (file) {
            // Crear una URL de objeto para la imagen seleccionada
            const previewURL = URL.createObjectURL(file);
            setFile(file);
            setPreview(previewURL);
        }
    };
    const handleEditarImagenBanner = (idProducto) => {
        const formData = new FormData();
        formData.append('idProducto', idProducto);
        formData.append('updateAction', 'update'); // Campo adicional para indicar que es una actualización

        if (nuevaImagen) {
            formData.append('imagen1', nuevaImagen);
        }
        if (nuevaImagen2) {
            formData.append('imagen2', nuevaImagen2);
        }
        if (nuevaImagen3) {
            formData.append('imagen3', nuevaImagen3);
        }
        if (nuevaImagen4) {
            formData.append('imagen4', nuevaImagen4);
        }

        fetch(`${baseURL}/productoImagePut.php`, {
            method: 'POST',  // Cambiado a POST
            body: formData
        })
            .then(response => {
                // Manejar el caso cuando la respuesta no es un JSON válido o está vacía
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');

                }

                return response.json();
            })
            .then(data => {
                if (data.error) {

                    toast.error(data.error);
                } else {

                    toast.success(data.mensaje);
                    window.location.reload();
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };

    const handleEsAccesorioChange = (e) => {
        setNuevoEsAccesorio(e.target.value);
        if (e.target.value == "si") {
            setViewAllSizes(false);
        } else {
            setViewAllSizes(true);
        }
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    useEffect(() => {
        cargarCategoria();
    }, []);


    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const cambiarOrden = (idProducto1, idProducto2, nuevoOrden1, nuevoOrden2) => {
        fetch(`${baseURL}/productosOrdenPut.php`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                idProducto1,
                idProducto2,
                nuevoOrden1,
                nuevoOrden2
            }),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {
                    // Error al cambiar orden
                } else {
                    cargarProductos();
                }
            })
            .catch(error => console.error('Error al cambiar el orden:', error));
    };

    const moverArriba = (index) => {
        if (index === 0) return; // El primer producto no se puede mover hacia arriba
        const productoActual = productos[index];
        const productoAnterior = productos[index - 1];
        cambiarOrden(productoActual.idProducto, productoAnterior.idProducto, productoAnterior.orden, productoActual.orden);
    };

    const moverAbajo = (index) => {
        if (index === productos.length - 1) return; // El último producto no se puede mover hacia abajo
        const productoActual = productos[index];
        const productoSiguiente = productos[index + 1];
        cambiarOrden(productoActual.idProducto, productoSiguiente.idProducto, productoSiguiente.orden, productoActual.orden);
    };

    return (
        <div>

            <ToastContainer />
            <div className='deFlexContent'>

                <div className='deFlex2'>
                    <NewProduct />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                    <button className='importar' onClick={() => setModalImportacionVisible(true)}><FontAwesomeIcon icon={faUpload} /> Importar</button>
                </div>
                <div className='filtrosContain'>
                    <div className='inputsColumn'>
                        <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Producto' />
                    </div>

                    <div className='inputsColumn'>
                        <input type="text" value={filtroTitulo} onChange={(e) => setFiltroTitulo(e.target.value)} placeholder='Titulo' />
                    </div>

                    <div className='inputsColumn'>
                        <select value={filtroCategoria} onChange={(e) => {
                            setFiltroCategoria(e.target.value);
                            paginate(1)
                        }}>
                            <option value="">Categorias</option>
                            {
                                categorias.map(item => (
                                    <option key={item.idCategoria} value={item?.idCategoria}>{item?.categoria}</option>
                                ))
                            }
                        </select>
                    </div>

                    <button className='reload' onClick={recargarProductos}><FontAwesomeIcon icon={faSync} /></button>
                    <button className='reverse' onClick={invertirOrden}>
                        {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
                    </button>

                </div>

            </div>


            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">


                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>

                        <img src={imagenSeleccionada} alt="Imagen Seleccionada" />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                                <button
                                    className={selectedSection === 'imagenes' ? 'selected' : ''}
                                    onClick={() => handleSectionChange('imagenes')}
                                >
                                    Editar Imagenes
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset className={`required-field ${errores.titulo ? 'fieldset-error' : ''}`}>
                                    <legend>Título</legend>
                                    <input
                                        type="text"
                                        value={nuevoTitulo !== '' ? nuevoTitulo : producto.titulo}
                                        onChange={(e) => setNuevoTitulo(e.target.value)}
                                    />
                                    {errores.titulo && <div className="error-message">{errores.titulo}</div>}
                                </fieldset>
                                <fieldset className={`required-field ${errores.precio ? 'fieldset-error' : ''}`}>
                                    <legend>Precio</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecio !== '' ? nuevoPrecio : producto.precio}
                                        onChange={(e) => setNuevoPrecio(e.target.value)}
                                    />
                                    {errores.precio && <div className="error-message">{errores.precio}</div>}
                                </fieldset>
                                <fieldset id='descripcion'>
                                    <legend>Descripción</legend>
                                    <textarea
                                        type="text"
                                        value={nuevaDescripcion}
                                        onChange={(e) => setNuevaDescripcion(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset className={`required-field ${errores.categoria ? 'fieldset-error' : ''}`}>
                                    <legend>Categoria</legend>
                                    <select
                                        value={nuevaCategoria !== '' ? nuevaCategoria : producto.categoria}
                                        onChange={(e) => setNuevaCategoria(e.target.value)}
                                    >

                                        {
                                            categorias
                                                .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === producto.idCategoria)
                                                .map(categoriaFiltrada => (

                                                    <option value={producto.categoria}> {categoriaFiltrada.categoria}</option>
                                                ))
                                        }

                                        {
                                            categorias.map(item => (
                                                <option value={item?.idCategoria}>{item?.categoria}</option>
                                            ))
                                        }
                                    </select>
                                    {errores.categoria && <div className="error-message">{errores.categoria}</div>}
                                </fieldset>

                                <fieldset className={`required-field ${errores.esAccesorio ? 'fieldset-error' : ''}`}>
                                    <legend>es Accesorio</legend>
                                    <select
                                        value={nuevoEsAccesorio !== '' ? nuevoEsAccesorio : producto.esAccesorio}
                                        onChange={handleEsAccesorioChange}
                                    >
                                        <option value="">Selecciona opción</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                    {errores.esAccesorio && <div className="error-message">{errores.esAccesorio}</div>}
                                </fieldset>

                                <fieldset className={`required-field ${errores.masVendido ? 'fieldset-error' : ''}`}>
                                    <legend>Más vendido</legend>
                                    <select
                                        value={nuevoMasVendido !== '' ? nuevoMasVendido : producto.masVendido}
                                        onChange={(e) => setNuevoMasVendido(e.target.value)}
                                    >
                                        <option value="">Selecciona opción</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>
                                    </select>
                                    {errores.masVendido && <div className="error-message">{errores.masVendido}</div>}
                                </fieldset>
                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioAnterior !== '' ? nuevoPrecioAnterior : producto.precioAnterior}
                                        onChange={(e) => setNuevoPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Módulo</legend>
                                    <input
                                        type="text"
                                        id="modulo"
                                        name="modulo"
                                        value={modulo !== '' ? modulo : producto.modulo}
                                        onChange={(e) => setNuevoModulo(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Nivel</legend>
                                    <input
                                        type="text"
                                        id="nivel"
                                        name="nivel"
                                        value={nivel !== '' ? nivel : producto.nivel}
                                        onChange={(e) => setNuevoNivel(e.target.value)}
                                    />
                                </fieldset>
                                <div className='items'>
                                    <fieldset>
                                        <legend>Item 1</legend>
                                        <input
                                            type="text"
                                            id="item1"
                                            name="item1"
                                            required
                                            value={item1}
                                            onChange={(e) => setItem1(e.target.value)}
                                            disabled
                                        />
                                    </fieldset>
                                    <fieldset>
                                        <legend>Stock Item 1</legend>
                                        <input
                                            type="number"
                                            id="stockItem1"
                                            name="stockItem1"
                                            required
                                            value={stockItem1}
                                            onChange={(e) => setStockItem1(e.target.value)}
                                        />
                                    </fieldset>

                                    {viewAllSizes && (
                                        <>
                                            <fieldset>
                                                <legend>Item 2</legend>
                                                <input
                                                    type="text"
                                                    id="item2"
                                                    name="item2"
                                                    required
                                                    value={item2}
                                                    onChange={(e) => setItem2(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Stock Item 2</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem2"
                                                    name="stockItem2"
                                                    required
                                                    value={stockItem2}
                                                    onChange={(e) => setStockItem2(e.target.value)}
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Item 3</legend>
                                                <input
                                                    type="text"
                                                    id="item3"
                                                    name="item3"
                                                    required
                                                    value={item3}
                                                    onChange={(e) => setItem3(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Stock Item 3</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem3"
                                                    name="stockItem3"
                                                    required
                                                    value={stockItem3}
                                                    onChange={(e) => setStockItem3(e.target.value)}
                                                />
                                            </fieldset>

                                            <fieldset>
                                                <legend>Item 4</legend>
                                                <input
                                                    type="text"
                                                    id="item4"
                                                    name="item4"
                                                    required
                                                    value={item4}
                                                    onChange={(e) => setItem4(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Stock Item 4</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem4"
                                                    name="stockItem4"
                                                    required
                                                    value={stockItem4}
                                                    onChange={(e) => setStockItem4(e.target.value)}
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Item 5</legend>
                                                <input
                                                    type="text"
                                                    id="item5"
                                                    name="item5"
                                                    required
                                                    value={item5}
                                                    onChange={(e) => setItem5(e.target.value)}
                                                    disabled
                                                />
                                            </fieldset>
                                            <fieldset>
                                                <legend>Stock Item 5</legend>
                                                <input
                                                    type="number"
                                                    id="stockItem5"
                                                    name="stockItem5"
                                                    required
                                                    value={stockItem5}
                                                    onChange={(e) => setStockItem5(e.target.value)}
                                                />
                                            </fieldset>
                                        </>
                                    )}
                                </div>
                            </div>

                            <button className='btnPost' onClick={() => handleUpdateText(producto.idProducto)} >Guardar </button>

                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagenes' ? 'flex' : 'none' }}>
                            <div className='previevProduct'>

                                {imagenPreview ? (
                                    <img src={imagenPreview} alt="Vista previa de la imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />
                                ) : (
                                    <>
                                        {producto.imagen1 ? (
                                            <img src={producto.imagen1} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}

                                {imagenPreview2 ? (
                                    <img src={imagenPreview2} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen2 ? (
                                            <img src={producto.imagen2} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen2)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}
                                {imagenPreview3 ? (
                                    <img src={imagenPreview3} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen3 ? (
                                            <img src={producto.imagen3} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen3)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}
                                {imagenPreview4 ? (
                                    <img src={imagenPreview4} alt="Vista previa de la imagen" />
                                ) : (
                                    <>
                                        {producto.imagen4 ? (
                                            <img src={producto.imagen4} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen4)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                            <fieldset>
                                <legend>Editar Imagen1 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen, setImagenPreview)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen2 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen2, setImagenPreview2)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen3 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen3, setImagenPreview3)} />
                            </fieldset>
                            <fieldset>
                                <legend>Editar Imagen4 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen4, setImagenPreview4)} />
                            </fieldset>


                            <button className='btnPost' onClick={() => handleEditarImagenBanner(producto.idProducto)}>Guardar </button>

                        </div>



                    </div>
                </div>
            )}
            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>Id Producto</th>
                            <th>Titulo</th>
                            <th>Precio</th>
                            <th>Categoria</th>
                            <th>Imagen</th>
                            <th>Imagen 2</th>
                            <th>Imagen 3</th>
                            <th>Imagen 4</th>
                            <th style={{ width: '200px' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.map((item, index) => (
                            <tr key={item.idProducto}>
                                <td>{item.idProducto}</td>
                                <td>{item.titulo}</td>

                                <td style={{
                                    color: '#008000',
                                }}>
                                    {moneda} {`${item?.precio}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}
                                </td>

                                {categorias
                                    .filter(categoriaFiltrada => categoriaFiltrada.idCategoria === item.idCategoria)
                                    .map(categoriaFiltrada => (
                                        <td
                                            key={categoriaFiltrada.idCategoria}
                                            style={{ color: '#DAA520' }}
                                        >
                                            {categoriaFiltrada.categoria}
                                        </td>
                                    ))
                                }

                                <td>
                                    {item.imagen1 ? (
                                        <img src={item.imagen1} alt="imagen1" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    {item.imagen2 ? (
                                        <img src={item.imagen2} alt="imagen2" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    {item.imagen3 ? (
                                        <img src={item.imagen3} alt="imagen3" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>
                                <td>
                                    {item.imagen4 ? (
                                        <img src={item.imagen4} alt="imagen4" />
                                    ) : (
                                        <span className='imgNonetd'>
                                            Sin imagen
                                        </span>
                                    )}
                                </td>

                                <td>
                                    {
                                        filtroCategoria !== '' &&
                                        <>
                                            <button onClick={() => moverArriba(index)} className='btnCategori'>
                                                <FontAwesomeIcon icon={faChevronUp} />
                                            </button>
                                            <button onClick={() => moverAbajo(index)} className='btnCategori'>
                                                <FontAwesomeIcon icon={faChevronDown} />
                                            </button>
                                        </>
                                    }

                                    <button className='eliminar' onClick={() => eliminarProducto(item.idProducto)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                    <button className='editar' onClick={() => abrirModal(item)}>
                                        <FontAwesomeIcon icon={faEdit} />
                                    </button>
                                    <Anchor className='editar' to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}>
                                        <FontAwesomeIcon icon={faEye} />
                                    </Anchor>
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
            {/* Componente de paginación */}
            <div className="pagination">
                <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    &laquo; Anterior
                </button>

                {Array.from({ length: Math.ceil(productosFiltrados.length / itemsPerPage) }).map((_, index) => (
                    <button
                        key={index}
                        onClick={() => paginate(index + 1)}
                        className={currentPage === index + 1 ? 'active' : ''}
                    >
                        {index + 1}
                    </button>
                ))}

                <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === Math.ceil(productosFiltrados.length / itemsPerPage)}
                >
                    Siguiente &raquo;
                </button>
            </div>
            
            {/* Componente de Importar Productos */}
            <ImportarProductos 
                modalImportacionVisible={modalImportacionVisible}
                setModalImportacionVisible={setModalImportacionVisible}
                cargarProductos={cargarProductos}
                cargarCategoria={cargarCategoria}
            />
        </div>
    );
};
